/**
 * AmbientBubbleColumns — tiny rising bubbles in the background for depth.
 *
 * Three emitters at random X positions spawn slow-rising sapphire-tinted
 * bubble particles behind the gameplay. Adds the "breathing ocean" feel
 * Overwatch-style intros have.
 *
 * Usage (once per gameplay scene):
 *   AmbientBubbleColumns.install(this);
 */

import Phaser from 'phaser';
import { GAME_CONFIG, graphicsState } from '@/config/constants';

export class AmbientBubbleColumns {
  static install(scene: Phaser.Scene): void {
    // Skip on low graphics
    try {
      if (graphicsState.getConfig?.().ambientParticles === false) return;
    } catch {}

    const { WIDTH, HEIGHT } = GAME_CONFIG;

    // Ensure pixel texture exists
    if (!scene.textures.exists('ambient_bubble_dot')) {
      const g = scene.add.graphics();
      g.fillStyle(0xFFFFFF, 1);
      g.fillCircle(4, 4, 4);
      g.generateTexture('ambient_bubble_dot', 8, 8);
      g.destroy();
    }

    // Three rising columns at random X, each slightly different
    const xs = [WIDTH * 0.2, WIDTH * 0.55, WIDTH * 0.85];
    const tints = [0x9EE8F4, 0x5A8EEA, 0xA7F3D0]; // aqua / sapphire / mint
    for (let i = 0; i < xs.length; i++) {
      const emitter = scene.add.particles(xs[i], HEIGHT + 20, 'ambient_bubble_dot', {
        x: { min: -80, max: 80 },
        y: 0,
        quantity: 1,
        frequency: 220 + i * 90,
        lifespan: { min: 5500, max: 7500 },
        speedY: { min: -80, max: -160 },
        speedX: { min: -20, max: 20 },
        scale: { start: 0.3, end: 0.9 },
        alpha: { start: 0.4, end: 0 },
        tint: tints[i % tints.length],
        blendMode: Phaser.BlendModes.ADD,
      });
      emitter.setDepth(4).setScrollFactor(0.3);
    }
  }
}
